



















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

import Avatar from "./Avatar.vue";
import { Profile } from "../types";

@Component({
  components: {
    Avatar,
  },
})
export default class ProfileItem extends Vue {
  @Prop({ required: true }) profile!: Profile;
  @Getter("curProfile") curProfile!: Profile;

  get name(): string {
    if (this.profile.name)
      return `${this.profile.name.title}. ${this.profile.name.first} ${this.profile.name.last}`;
    return "";
  }
}
